import React, { useEffect, useState, useRef } from 'react';
import { MailIcon, MessageSquareIcon, MoreHorizontalIcon, CopyIcon, TrashIcon } from 'lucide-react';
export function Toolbar() {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <div className="bg-white shadow-sm rounded-lg p-2 mx-4 md:mx-6 mb-4 flex flex-wrap gap-2" data-id="element-492">
      <button className="flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-493">
        <MailIcon className="w-4 h-4" data-id="element-494" />
        <span data-id="element-495">Email</span>
      </button>
      <button className="flex items-center gap-1.5 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors" data-id="element-496">
        <MessageSquareIcon className="w-4 h-4" data-id="element-497" />
        <span data-id="element-498">SMS</span>
      </button>
      <div className="relative" ref={dropdownRef} data-id="element-499">
        <button className="flex items-center gap-1.5 px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors" onClick={() => setShowDropdown(!showDropdown)} data-id="element-500">
          <MoreHorizontalIcon className="w-4 h-4" data-id="element-501" />
          <span data-id="element-502">More</span>
        </button>
        {showDropdown && <div className="absolute right-0 mt-1 w-40 bg-white shadow-lg rounded-md border border-gray-200 z-10" data-id="element-503">
            <button className="flex items-center gap-2 w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 transition-colors" data-id="element-504">
              <CopyIcon className="w-4 h-4" data-id="element-505" />
              <span data-id="element-506">Copy</span>
            </button>
            <button className="flex items-center gap-2 w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 transition-colors" data-id="element-507">
              <TrashIcon className="w-4 h-4" data-id="element-508" />
              <span data-id="element-509">Delete</span>
            </button>
          </div>}
      </div>
    </div>;
}